import { render } from "./BalavediMadrasa.vue?vue&type=template&id=045b6f44&scoped=true"
import script from "./BalavediMadrasa.vue?vue&type=script&lang=js"
export * from "./BalavediMadrasa.vue?vue&type=script&lang=js"

import "./BalavediMadrasa.vue?vue&type=style&index=0&id=045b6f44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045b6f44"]])

export default __exports__